import { render, staticRenderFns } from "./ConfirmationCode.vue?vue&type=template&id=344cb3c5&"
import script from "./ConfirmationCode.vue?vue&type=script&lang=js&"
export * from "./ConfirmationCode.vue?vue&type=script&lang=js&"
import style0 from "./ConfirmationCode.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
installComponents(component, {VBtn,VCardText,VForm,VOtpInput})
